import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { Select } from "antd";
import CustomChip from "../general/chips";
import VaporFormItem from "../vapor/form";
import { intersectionBy } from "../../libs/arrayUtils";
import moment from "moment";
import { VaporRangeDatePicker } from "../vapor";

const Option = Select.Option;

const MovementsHeader = ({
  isAccountingPage,
  onFiltersMovementsChange,
  setStartDate,
  setEndDate,
  reconciliation,
  setFilterIban,
  filterIban,
  startDate,
  endDate,
  setMovementsToShow,
  movements,
  setFilteredData,
  accountingData,
  activeFilters,
  setFilterDateRange
}) => {
  useEffect(() => {
    if (isAccountingPage) {
      setStartDate(moment()
        .subtract(2, "y")
        .format("YYYY-MM-DD"));
      setEndDate(moment()
        .endOf("day")
        .format("YYYY-MM-DD"));
    }
  }, []);

  useEffect(() => {
    // creo un oggetto che abbia come chiavi gli stessi nomi dati ai filtri che popolano l'array di filtri attivi (active filters)
    // e come valori delle funzioni di filtro (a parte per il "tutti") che tornano degli array filtrati (map)
    const filtersObject = !isAccountingPage
      ? {
        all: movements,
        collects: movements?.filter(m => Math.sign(m.amount) === 1),
        payments: movements?.filter(m => Math.sign(m.amount) === -1),
        toLink: movements?.filter(m => (m.linked === false && m.linkable === true)),
        linked: movements?.filter(m => m.linked === true),
        notLinkable: movements?.filter(m => m.linkable === false)
      }
      : {
        all: accountingData,
        collects: accountingData?.filter(m => Math.sign(m.amount) === 1),
        payments: accountingData?.filter(m => Math.sign(m.amount) === -1),
        toLink: accountingData?.filter(m => (m.linked === false && m.linkable === true)),
        linked: accountingData?.filter(m => m.linked === true),
        notLinkable: accountingData?.filter(m => m.linkable === false)
      };
    let filtersToIntersect = [];
    // popolo un array (filtersToIntersect) con gli array di cui vogliamo l'intersezione, mappando i filtri attivi con i nomi
    // delle chiavi dell'oggetto su definito
    // eslint-disable-next-line no-undefined
    if (activeFilters !== undefined) {
      activeFilters.flatMap(x => {
        if (filtersObject[x]) {
          filtersToIntersect.push(filtersObject[x]);
        }
        return filtersToIntersect;
      });
    }
    // ottengo l'array dei filtri finali facendo un'intersezione tra gli array sopra ricavati
    const finalFilters = filtersToIntersect.length === 0 ? []
      : (filtersToIntersect.length === 1 ? filtersToIntersect[0] : intersectionBy(
        filtersToIntersect[0], filtersToIntersect[1], "id"
      ));

    // filtro i movimenti anche per conto iban selezionato

    const movToShowCopy = [...finalFilters];
    const ibanFiltered = movToShowCopy.filter(mov => mov.iban === filterIban);

    // ottengo i movimenti da mostrare a schermo facendo un'intersezione tra gli array degli altri filtri finali e l'array dei movimenti filtrati per iban
    const movToShow = intersectionBy(
      finalFilters, ibanFiltered, "id"
    );

    // setto i movimenti da mostrare nella funzione di render sull'array dei filtri finali
    if (!isAccountingPage) {
      setMovementsToShow(filterIban === "all" ? [...finalFilters] : [...movToShow]);
    } else {
      setFilteredData(filterIban === "all" ? [...finalFilters] : [...movToShow]);
    }
  }, [movements, accountingData, activeFilters, filterIban]);

  useEffect(() => {
    // eslint-disable-next-line no-undefined
    if (isAccountingPage && accountingData !== undefined) {
      let filtered = [];
      accountingData.forEach(data => {
        if (
          moment(data?.doc?.date) >= moment(startDate) &&
          moment(data?.doc?.date) <= moment(endDate)
        ) {
          filtered.push(data);
        }
      });
      setFilteredData([...filtered]);
    }
  }, [startDate, endDate]);

  const listFilterIban = () => {
    let items = [];
    let ibans = [];
    if (
      reconciliation &&
      reconciliation?.movements &&
      reconciliation?.movements.list
    ) {
      reconciliation.movements.list.map(movement => {
        if (ibans.indexOf(movement.iban) === -1) {
          ibans.push(movement.iban);
          items.push(<Option
            key={"dbx-reconciliation-filter-iban_" + movement.iban}
            value={movement.iban}
          >
            {movement.iban}
          </Option>);
        }
        return null;
      });
    }
    return items;
  };

  return (
    <div
      className="dbx-reconciliation-movements-filters-container"
      style={{
        display: isAccountingPage ? "flex" : "block",
        width: isAccountingPage && "45%",
        justifyContent: isAccountingPage && "space-between",
        margin: isAccountingPage ? "44px 0 46px 52px" : "44px 0 46px"
      }}
    >
      <div
        className="dbx-reconciliation-movements-title"
        style={{ width: isAccountingPage && "60%" }}
      >
        <div>
          {useIntl().formatMessage({ id: "reconciliation.movements.title" })}
        </div>{" "}
        <div>
          <Select
            getPopupContainer={trigger => trigger.parentNode}
            className="dbx-reconciliation-movements-filter-iban"
            value={filterIban}
            onChange={value => setFilterIban(value)}
            dropdownClassName="dbx-reconciliation-movements-filter-iban-dropdown"
          >
            <Option key="dbx-reconciliation-filter-iban_all" value="all">
              Tutti i conti
            </Option>
            {listFilterIban()}
          </Select>
        </div>
      </div>
      <div
        className="dbx-reconciliation-movements-filters"
        style={{ width: isAccountingPage && "40%" }}
      >
        <div className="dbx-reconciliation-movements-filter-left">
          <VaporFormItem label="Date">
            <VaporRangeDatePicker
              className="dbx-reconciliation-movements-date-picker"
              onChange={e => {
                setFilterDateRange(true);
                if (e && e.length !== 0) {
                  setStartDate(e[0]?.format("YYYY-MM-DD"));
                  setEndDate(e[1]?.format("YYYY-MM-DD"));
                  onFiltersMovementsChange("date", e);
                } else {
                  setStartDate(moment()
                    .startOf("month")
                    .format("YYYY-MM-DD"));
                  setEndDate(moment()
                    .endOf("month")
                    .format("YYYY-MM-DD"));
                }
              }}
            />
          </VaporFormItem>
        </div>
        <div className="dbx-reconciliation-movements-filter-right">
          <VaporFormItem label="Filtri">
            <div>
              <div style={{ display: "flex" }}>
                <CustomChip
                  active={activeFilters?.includes("all")}
                  onClick={() => onFiltersMovementsChange("type", "all")}
                  description={"Tutti"}
                />
                <CustomChip
                  active={activeFilters?.includes("collects")}
                  onClick={() => onFiltersMovementsChange("type", "collects")}
                  description={"Entrate"}
                />
                <CustomChip
                  active={activeFilters?.includes("payments")}
                  onClick={() => onFiltersMovementsChange("type", "payments")}
                  description={"Uscite"}
                />
              </div>
              {!isAccountingPage && (
                <div style={{ display: "flex" }}>
                  <CustomChip
                    active={activeFilters?.includes("toLink")}
                    onClick={() => onFiltersMovementsChange("type", "toLink")}
                    description={"Da Riconciliare"}
                  />
                  <CustomChip
                    active={activeFilters?.includes("linked")}
                    onClick={() => onFiltersMovementsChange("type", "linked")}
                    description={"Riconciliati"}
                  />
                  <CustomChip
                    active={activeFilters?.includes("notLinkable")}
                    onClick={() =>
                      onFiltersMovementsChange("type", "notLinkable")
                    }
                    description={"Non Riconciliabile"}
                  />
                </div>
              )}
            </div>
          </VaporFormItem>
        </div>
      </div>
    </div>
  );
};

export default MovementsHeader;
